import { render, staticRenderFns } from "./VerticalNavMenuGroup.vue?vue&type=template&id=011602ac&"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011602ac')) {
      api.createRecord('011602ac', component.options)
    } else {
      api.reload('011602ac', component.options)
    }
    module.hot.accept("./VerticalNavMenuGroup.vue?vue&type=template&id=011602ac&", function () {
      api.rerender('011602ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vertical-nav-menu/VerticalNavMenuGroup.vue"
export default component.exports